import { Routes, Route } from 'react-router-dom';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { Rotationsplan } from '@/domain/mitarbeiter/pages/rotationsplan';

export function Mitarbeiter() {
  return (
    <Routes>
      <Route
        path="/rotationsplan"
        element={
          <WithFeatureFlags name="rotationsplan">
            <Rotationsplan />
          </WithFeatureFlags>
        }
      />
      <Route
        path="/rotationsplan/:year"
        element={
          <WithFeatureFlags name="rotationsplan">
            <Rotationsplan />
          </WithFeatureFlags>
        }
      />
      <Route
        path="/rotationsplan/:year/:view"
        element={
          <WithFeatureFlags name="rotationsplan">
            <Rotationsplan />
          </WithFeatureFlags>
        }
      />
    </Routes>
  );
}
